module.exports = __webpack_public_path__ + "assets/img/featured-4.11f3d0cc.jpg";